import { getFormattedDuration } from "../../../../utils/dateTime/library";
import { captionsIcon } from "./constants";
import { number, bool } from "prop-types";
import { FormattedAirDate } from "../FormattedDate/component";

const VideoTimeLabel = ({
    videoAirDate = null,
    videoDuration = null,
    captions = false,
    isLive = false,
}) => {
    const ccDiv = captions ? captionsIcon : null;

    const displayDuration = !isLive && videoDuration > 0;

    const getDurationLabel = () => {
        if (!displayDuration) return null;

        const formattedDuration = getFormattedDuration(videoDuration);
        return (
            <div className="durationLabel">
                <span>
                    <span className="a11y">Duration </span>
                    {formattedDuration}
                </span>
                {ccDiv}
            </div>
        );
    };

    const getLiveLabel = () => {
        return videoAirDate < Date.now() ? (
            <div className="liveLabel">
                <span>Live</span>
                {ccDiv}
            </div>
        ) : (
            <div className="upcomingLabel">
                <div className="labelAndCaptions">
                    <span>Live in</span>
                    {ccDiv}
                </div>
                <div className="upcomingTime">
                    <FormattedAirDate airDate={videoAirDate} />
                </div>
            </div>
        );
    };

    return (
        <div className="videoTimeLabel" data-testid="video-time-label">
            {isLive ? getLiveLabel() : getDurationLabel()}
        </div>
    );
};

VideoTimeLabel.propTypes = {
    videoDuration: number,
    videoAirDate: number,
    captions: bool,
    isLive: bool,
};

export default VideoTimeLabel;
